import { Component, OnDestroy, OnInit, Inject, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { AuthService } from '../../services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import 'rxjs/add/operator/takeUntil';
import { Data } from '../../models/data';
import { Router } from '@angular/router';
/*import {MatPaginator, MatTableDataSource} from '@angular/material';
import { Classification } from '../../models/classification';*/



export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-classification',
  templateUrl: './classification.page.html',
  styleUrls: ['./classification.page.scss'],
})

export class ClassificationPage implements OnInit, OnDestroy {

  myresponse: any;
  verify = false;

  myresult: any;
  myId: any;
  custId: any;

  data = new Data();
  classification: any;
  listing: any;
  class: any;

  list: any;
  open(menu)
  {
    menu.openMenu();
  }
  
  current_year: number = new Date().getFullYear();

  is_classification_name = false;
  msg_classification_name = 'Classification Name is required';

  acc_classification = {
    name: null
  }

  constructor(private apiService: ApiService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private navCtrl: NavController,
    private spinner: NgxSpinnerService) {

      this.myresult = '';
      this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
      this.custId = this.activatedRoute.snapshot.paramMap.get('custid');
      const user = localStorage.getItem('user');
  
      this.data = {
        id: 3,
        name: 'getParamDashboard',
        content: user
      };
  


  }



  ngOnInit() 
  {
    this.getClass();

    this.data = {
      id: 7,
      name: 'getListClassification',
      content: {
        id: localStorage.getItem('user'),
      }
    };

    console.log(this.data);

    this.apiService.postData(this.data).subscribe((response) => {
    this.classification = response.data;
    this.listing = this.classification;

    this.listing.forEach(e => {
      console.log(e);

      e.checked = false;
      
    });
      
  });
  }

  updateClassification() 
  {
    console.log(this.listing);

    this.data = {
      id: 7,
      name: 'updateClassificationMain',
      content: {
        id: localStorage.getItem('user'),
        data: this.listing
      }
    };

    console.log(this.data);
    this.apiService.postData(this.data).subscribe((response) => {

      this.router.navigate(['/members/classification']).then(() => {

      this.data = {
        id: 7,
        name: 'getListClassification',
        content: {
          id: localStorage.getItem('user'),
        }
      };

        console.log(this.data);
          this.apiService.postData(this.data).subscribe((response) => {
          this.classification = response.data;
          this.listing = this.classification;

          this.listing.forEach(e => {
            console.log(e);

            e.checked = false;
            
          });
            
        });
        
      });


    });
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(DialogClassificationPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  submitClassification() 
  {
    this.spinner.show();
    
    this.data.id = 1;
    this.data.name = 'createClassificationName';
    this.data.content = this.acc_classification;

    this.apiService.postData(this.data).subscribe((response) => {
      this.spinner.hide();
      this.openDialog();
      this.router.navigate(['/members/classification']);
    });

  }

  classificationname() {
    if (this.acc_classification.name == null || this.acc_classification.name == undefined) {
      this.is_classification_name = false;
    } else if (this.acc_classification.name.length == 0) 
    {
      this.is_classification_name = false;
    } 
    else if (this.acc_classification.name.length == "") 
    {
      this.is_classification_name = false;
    }
    else
    {
      this.is_classification_name = true;
    }

    console.log("name = " + this.acc_classification.name);
    console.log("is_classification_name = " + this.acc_classification.name);

  }

  ngOnDestroy() 
  {
  }

  logout() {
    this.authService.logout();
  }

  getClass() 
  {

    this.data = {
      id: 7,
      name: 'getListClassificationCategory',
      content: {
        id: localStorage.getItem('user'),
      }
    };

    this.apiService.postData(this.data).subscribe((response) => {

      this.class = response.data;

    });

  }

  onInput(event: Event): void {
    this.list = +(<HTMLInputElement>event.target).value.split(',').join('');
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogClassificationPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}